<div #iconContainer class="d-flex" [innerHtml]="selectedSvg"></div>
